<app-stat-card
  titleKey="liveDashboard.qualitaet.module.title"
  subtitleKey="liveDashboard.qualitaet.module.subtitle"
  sectionLabelKey="liveDashboard.qualitaet.module.mostUsed"
  [stats]="stats()"
>
  @if (topModules().length === 0) {
    <p class="testmodule-stats__empty">{{ 'liveDashboard.qualitaet.module.empty' | translate }}</p>
  } @else {
    <ul class="testmodule-stats__list">
      @for (item of topModules(); track item.id) {
        <li class="testmodule-stats__item">
          @if (item.key) {
            <code class="testmodule-stats__chip">{{ item.key }}</code>
          }
          <span class="testmodule-stats__name">{{ item.name }}</span>
          <span class="testmodule-stats__usage">
            {{ 'liveDashboard.qualitaet.module.usage' | translate: { count: item.verwendungen } }}
          </span>
        </li>
      }
    </ul>
  }
</app-stat-card>
